import Updated from '@/components/Icons/Updated';
import useTranslation from '@/hooks/useTranslation';
import type { IContentItem } from '@/interfaces';
import type { FC } from 'react';
import type { FCl } from 'react-fc';
import { Badge } from '../../Atoms/Badge/Badge';

const STATUS_VALUES: Record<IContentItem['contentStatus'], { text: string; icon?: FC }> = {
    archived: {
        text: 'common:ContentBadge.archived',
        icon: null,
    },
    new: {
        text: 'common:ContentBadge.new',
        icon: null,
    },
    updated: {
        text: 'common:ContentBadge.updated',
        icon: Updated,
    },
};

export interface IContentStatusProps {
    status?: IContentItem['contentStatus'];
}

// status values from api/common/src/Domain/ValueObject/ContentStatus.php
export const ContentStatus: FCl<IContentStatusProps> = ({ status, className }) => {
    const { t } = useTranslation();

    if (!STATUS_VALUES[status]) {
        return null;
    }

    const Icon = STATUS_VALUES[status].icon;
    const colorBadge = status === 'archived' ? 'default' : 'yellow';
    return (
        <Badge
            className={className}
            text={t(`common:ContentBadge.${status}`)}
            colorVar={colorBadge}
            icon={Icon && <Icon />}
        />
    );
};
